<section>
  <h1>Information Reports</h1>
  <ness-local-filter [storageKey]="storageKey" (filterModel)="applyFilters($event)"></ness-local-filter>
  <p-messages key="irsMsg" [closable]="true"></p-messages>
  <a *removeIfUnauthorizedIR="canCreate" class="btn btn-active mb-3" (click)="newInfoReport()">Add Information Report</a>
  <p-table #dt [columns]="cols" [value]="infoReports" [paginator]="true" [alwaysShowPaginator]="false" [rows]="rows" [autoLayout]="true" responsiveLayout="scroll" [customSort]="true" (sortFunction)="customSort($event)" [globalFilterFields]="['IntelligenceTrackingNumber','CreatedOn','Title','Status', 'IRPurposes', 'PrimaryCrimeGunNumber', 'MostRecentTriageData', 'AssignedCGICPersonnel', 'DateSent', 'ENESS_XREF_SuccessStoriesResults']">
    <ng-template pTemplate="caption">
      <div class="d-flex flex-wrap p-2 mx-2 filter-status font-size-sm">
        <ness-paged-loading-status *ngIf="loading" [startRow]="loadingStartRow$ | async" [endRow]="loadingEndRow$ | async" [messageTemplate]="messageTemplate"></ness-paged-loading-status>
        <div class="ms-md-2 ms-lg-auto me-2">
          <div class="input-group">
            <span class="input-group-text"><i class="fa fa-search" aria-hidden="true"></i></span>
            <input type="text" class="form-control" name="irGridGlobalFilter" placeholder="Global filter" (input)="filterGlobal($event['target']['value'], 'global', 'contains')" aria-label="Globally filter the information reports grid">
          </div>
        </div>
      </div>
    </ng-template>
    <ng-template pTemplate="header" let-columns>
      <tr>
        <th *ngFor="let col of columns" [pSortableColumn]="col.field" scope="col">
          {{col.header}}
          <p-sortIcon [field]="col.field" ariaLabel="Activate to sort" ariaLabelDesc="Activate to sort in descending order" ariaLabelAsc="Activate to sort in ascending order"></p-sortIcon>
        </th>
      </tr>
      <tr>
        <th scope="col">
          <p-columnFilter field="IntelligenceTrackingNumber" matchMode="contains" [showMenu]="false" [showClearButton]="false" display="row">
            <ng-template pTemplate="filter" let-value let-filter="filterCallback">
              <input pInputText [ngModel]="value" name="irTrackingNumberFilter" type="text" class="form-control form-control-sm" (input)="filter($event['target']['value'])" aria-label="Filter by information report tracking number." />
            </ng-template>
          </p-columnFilter>
        </th>
        <th scope="col">
          <p-columnFilter [showMenu]="false" field="CreatedBy" [matchMode]="'contains'" [showClearButton]="false" display="row">
            <ng-template pTemplate="filter" let-value let-filter="filterCallback">
              <input pInputText [ngModel]="value" name="irCreatedByFilter" type="text" class="form-control form-control-sm" (input)="filter($event['target']['value'])" aria-label="Filter by created by." />
            </ng-template>
          </p-columnFilter>
        </th>
        <th scope="col">
          <p-columnFilter [showMenu]="false" field="CreatedOn" [matchMode]="'date'" [showClearButton]="false" display="row">
            <ng-template pTemplate="filter" let-value let-filter="filterCallback">
              <input pInputText [ngModel]="value" name="irCreatedOnFilter" type="text" class="form-control form-control-sm" (input)="customFilter('CreatedOn','CreatedOn', $event['target']['value'])" aria-label="Filter by created date." />
            </ng-template>
          </p-columnFilter>
        </th>
        <th scope="col">
          <p-columnFilter [showMenu]="false" field="ModifiedBy" [matchMode]="'contains'" [showClearButton]="false" display="row">
            <ng-template pTemplate="filter" let-value let-filter="filterCallback">
              <input pInputText [ngModel]="value" name="irModifiedByFilter" type="text" class="form-control form-control-sm" (input)="filter($event['target']['value'])" aria-label="Filter by last updated by." />
            </ng-template>
          </p-columnFilter>
        </th>
        <th scope="col">
          <p-columnFilter [showMenu]="false" field="ModifiedOn" [matchMode]="'date'" [showClearButton]="false" display="row">
            <ng-template pTemplate="filter" let-value let-filter="filterCallback">
              <input pInputText [ngModel]="value" name="irModifiedOnFilter" type="text" class="form-control form-control-sm" (input)="customFilter('ModifiedOn','ModifiedOn', $event['target']['value'])" aria-label="Filter by last updated on date." />
            </ng-template>
          </p-columnFilter>
        </th>
        <th scope="col">
          <p-columnFilter [showMenu]="false" field="Title" matchMode="contains" [showClearButton]="false" display="row">
            <ng-template pTemplate="filter" let-value let-filter="filterCallback">
              <input pInputText [ngModel]="value" name="irTitleFilter" type="text" class="form-control form-control-sm" (input)="filter($event['target']['value'])" aria-label="Filter by title." />
            </ng-template>
          </p-columnFilter>
        </th>
        <th scope="col">
          <p-columnFilter [showMenu]="false" field="Status" matchMode="contains" [showClearButton]="false" display="row">
            <ng-template pTemplate="filter" let-value let-filter="filterCallback">
              <input pInputText [ngModel]="value" name="irStatusFilter" type="text" class="form-control form-control-sm" (input)="filter($event['target']['value'])" aria-label="Filter by status." />
            </ng-template>
          </p-columnFilter>
        </th>
        <th scope="col">
          <p-columnFilter [showMenu]="false" field="IRPurposes" matchMode="contains" [showClearButton]="false" display="row">
            <ng-template pTemplate="filter" let-value let-filter="filterCallback">
              <input pInputText [ngModel]="value" name="irPurposesFilter" type="text" class="form-control form-control-sm" (input)="filter($event['target']['value'])" aria-label="Filter by purpose." />
            </ng-template>
          </p-columnFilter>
        </th>
        <th scope="col">
          <p-columnFilter [showMenu]="false" field="PrimaryCrimeGunNumber" matchMode="crimeGunNumber" [showClearButton]="false" display="row">
            <ng-template pTemplate="filter" let-value let-filter="filterCallback">
              <input pInputText [ngModel]="value" name="irPrimaryCGFilter" type="text" class="form-control form-control-sm" (input)="filter($event['target']['value'])" aria-label="Filter by primary crime gun number." />
            </ng-template>
          </p-columnFilter>
        </th>
        <th scope="col">
          <p-columnFilter [showMenu]="false" field="MostRecentTriageData" matchMode="triageData" [showClearButton]="false" display="row">
            <ng-template pTemplate="filter">
              <input pInputText type="text" name="irTriageFilter" class="form-control form-control-sm" (input)="customFilter('MostRecentTriageData','PrimaryCrimeGunNumber', $event['target']['value'])" aria-label="Filter by triage level and date" />
            </ng-template>
          </p-columnFilter>
        </th>
        <th scope="col">
          <p-columnFilter [showMenu]="false" field="AssignedCGICPersonnel" matchMode="personnel" [showClearButton]="false" display="row">
            <ng-template pTemplate="filter">
              <input pInputText type="text" name="irPersonnelFilter" class="form-control form-control-sm" (input)="customFilter('AssignedCGICPersonnel','AssignedCGICPersonnel', $event['target']['value'])" aria-label="Filter by assigned personnel" />
            </ng-template>
          </p-columnFilter>
        </th>
        <th scope="col">
          <p-columnFilter [showMenu]="false" field="DateSent" matchMode="date" [showClearButton]="false" display="row">
            <ng-template pTemplate="filter" let-value let-filter="filterCallback">
              <input [ngModel]="value" type="text" name="irDateSentFilter" class="form-control form-control-sm" (input)="customFilter('DateSent','DateSent', $event['target']['value'])" aria-label="Filter by the sent date." pInputText />
            </ng-template>
          </p-columnFilter>
        </th>
        <th scope="col">
          <p-columnFilter [showMenu]="false" field="ENESS_XREF_SuccessStoriesResults" matchMode="success" [showClearButton]="false" display="row">
            <ng-template pTemplate="filter" let-value let-filter="filterCallback">
              <input [ngModel]="value" type="text" name="irResultsFilter" class="form-control form-control-sm" (input)="filter($event['target']['value'])" aria-label="Filter by related results" pInputText />
            </ng-template>
          </p-columnFilter>
        </th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-rowData>
      <tr>
        <th scope="row">
          <ng-container *removeIfUnauthorizedIR="canViewIR(rowData); else noview">
            <button type="button" class="btn btn-sm btn-link" aria-label="{{'View information report '+rowData.IntelligenceTrackingNumber+' details'}}" tabindex="0" (click)="showInfoReportDetails(rowData)">{{rowData.IntelligenceTrackingNumber}}</button>
          </ng-container>
          <ng-template #noview>{{ rowData.IntelligenceTrackingNumber }}</ng-template>
        </th>
        <td>{{rowData.CreatedBy}}</td>
        <td>{{rowData.CreatedOn | utcToLocal:'MM/dd/yyyy'}}</td>
        <td>{{rowData.ModifiedBy}}</td>
        <td>{{rowData.ModifiedOn | utcToLocal:'MM/dd/yyyy'}}</td>
        <td>{{rowData.Title}}</td>
        <td>{{rowData.Status}}</td>
        <td [innerHTML]="rowData.IRPurposes | joinArray:';'  | lineBreakTransform:';'"></td>
        <td>
          <ul class="list-unstyled ">
            <li *ngFor="let cg of rowData.PrimaryCrimeGunNumber" class="text-nowrap">
              <ng-container *ngIf="!!cg.CrimeGunNumberID; else nocglink">
                <a (click)="openRelatedCrimeGun($event, cg.CrimeGunNumberID)">{{cg.CrimeGunNumber}}</a>
              </ng-container>
              <ng-template #nocglink>
                <span [pTooltip]="cg.IsOutsideAgency ? 'Outside Agency CGID' : 'CGID was deleted'">{{ cg.CrimeGunNumber }}</span>
              </ng-template>
            </li>
          </ul>
        </td>
        <td>
          <ul class="list-unstyled ">
            <li *ngFor="let cg of rowData.PrimaryCrimeGunNumber" class="text-nowrap">
              {{cg.MostRecentTriageLevel}}; {{cg.MostRecentTriageDate |  date:'MM/dd/yyyy'}}
            </li>
          </ul>
        </td>
        <td [innerHTML]="formatAssignedPersonnel(rowData.AssignedCGICPersonnel) | joinArray:';'  | lineBreakTransform:';'"></td>
        <td>{{rowData.DateSent | utcToLocal:'MM/dd/yyyy'}}</td>
        <td>
          <ul class="list-unstyled">
            <li *ngFor="let result of rowData.ENESS_XREF_SuccessStoriesResults">
              <button type="button" tabindex="0" class="btn btn-sm btn-link" aria-label="{{'View result '+result.ENESS_SuccessStory.InvestigativeTrackingNumber+' details'}}" (click)="showResultDetails(result)">{{result.ENESS_SuccessStory.InvestigativeTrackingNumber}}</button>
            </li>
          </ul>
        </td>
      </tr>
    </ng-template>
    <ng-template pTemplate="emptymessage">
      <tr>
        <td [attr.colspan]="10">
          No information reports found.
        </td>
      </tr>
    </ng-template>
  </p-table>
</section>
<p-sidebar (onShow)="onShowSidebar()" [(visible)]="showSidebar" position="right" [blockScroll]="true" styleClass="p-sidebar-lg" [showCloseIcon]="false" (onHide)="clearSidebar()">
  <ng-container *ngIf="showInfoReportDetailView">
    <ng-container *ngIf="selectedInfoReport$ | async as ir">
      <ness-info-report-detail tabindex="0" [infoReport]="ir"></ness-info-report-detail>
      <button type="button" (click)="showSidebar = showInfoReportDetailView = false" class="btn btn-active my-3">Close</button>
    </ng-container>
  </ng-container>
  <ng-container *ngIf="showRelatedResultDetailView">
    <ness-results-detail [resultId]="selectedResultId"></ness-results-detail>
  </ng-container>
</p-sidebar>
